import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DashboardService } from '../dashboard.service';
import { Tips } from '../models/tips';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { EventTypes } from '../../../shared/EventTypes';

@Component({
	selector: 'app-rename-account',
	templateUrl: './rename-account.component.html',
	styleUrls: ['./rename-account.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class RenameAccountComponent implements OnInit {

	public dataOfTip: Tips = new Tips();
	public allTips: Array<Tips> = new Array<Tips>();
	public isLoading = true;
	public noMoreTips = true;

	constructor(private dashboardService: DashboardService) { }

	ngOnInit() {
		this.getTips();
	}

	getTips() {
		this.dashboardService.getTips().subscribe((data) => {
			this.allTips = data;
			this.isLoading = false;
			this.noMoreTips = (this.allTips.length > 0) ? false : true;
			this.dataOfTip = this.allTips[0];
		}, error => {
			this.noMoreTips = true;
			this.isLoading = false;
		});
	}

	removeTip() {
		this.isLoading = true;

		this.dashboardService.removeTip(this.dataOfTip.tipId).subscribe((data) => {
			this.allTips.shift();

			this.dataOfTip = (this.allTips.length > 0) ? this.allTips[0] : new Tips();

			this.noMoreTips = (this.allTips.length > 0) ? false : true;

			this.isLoading = false;
		}, error => {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			this.isLoading = false;
		});

	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/dashboard/rename-account/rename-account.component.ts